define('pages/main/home',["jquery", "appquery", "app"], function($, $$, App) {
    $$ = $$('home');

    return {
        init : function() {
            App.idleTimer.stop();
            var logo = App.global('retailer_logo');
            if (typeof logo == 'undefined'){
                App.database.get('retailer_logo', function(data){
                    logo = data;
                }).then(function(){
                    App.database.get('icon-'+ logo +'.svg', function(data){
                        $$('#retailer_logo').attr('src',data);
                    });
                })
            }
            else{
                App.database.get('icon-'+ logo +'.svg', function(data){
                    $$('#retailer_logo').attr('src',data);
                });
            }
            $$('#explore').click(function(){
                App.page.render('map', {mode : 'explore'});
            });
            var clickCount = 0;
            $$('#zopsmart-logo').on('click', function() {
                clickCount += 1;
                App.utils.debounce(function() {
                    if(clickCount == 5) {
                        App.page.login({
                            onLogin : function() {
                                App.page.render('settings');
                            },
                            showFooter : true,
                        });
                    }
                    clickCount = 0;
                }, 3000)();
            });
        },
        exit : function(data) {
            App.idleTimer.start();
            return data;
        },
        footer : true
    };
});
